import { Card, CardContent } from "@/components/ui/card";
import { ProgressCircle } from "@/components/ui/charts/progress-circle";
import { Skeleton } from "@/components/ui/skeleton";
import { FC } from "react";

type ProgressSummarySkeletonProps = React.HTMLAttributes<HTMLDivElement>;

const ProgressSummarySkeleton: FC<ProgressSummarySkeletonProps> = (props) => {
  return (
    <Card className={props.className} {...props}>
      <CardContent className="pt-6">
        <h2 className="text-lg font-bold">Total del cuestionario</h2>

        <div className="my-4 flex items-center gap-4">
          <ProgressCircle
            value={0}
            radius={38}
            strokeWidth={10}
            backgroundVariant="neutral"
          >
            <span className="text-xs font-medium text-[#8090A3]">0%</span>
          </ProgressCircle>

          <div>
            <Skeleton style={{ width: "40px", height: "18px" }} />
            <span className="block text-xs">Preguntas respondidas</span>
          </div>
        </div>

        <h2 className="my-4 text-xs font-bold text-[#293038]">Por dimensión</h2>

        <div className="flex flex-col gap-4">
          {Array.from({ length: 5 }).map((_, index) => (
            <Skeleton key={index} style={{ width: "100%", height: "28px" }} />
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default ProgressSummarySkeleton;
